module.exports = __webpack_public_path__ + "media/react/marketing/pages/plans/sections/offers/assets/arrow_with_loop-2e1a826a8b20d845b24931428b465e49.svg";